import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth, API } from "../App";
import { Button } from "../components/ui/button";
import { CheckCircle, Loader2 } from "lucide-react";
import axios from "axios";

const LOGO_URL = "/images/singleseen_logo_transparent.png";

const PaymentSuccess = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const { token, refreshUser } = useAuth();
  const navigate = useNavigate();
  const [status, setStatus] = useState("checking");

  const isDirect = searchParams.get("direct") === "true";

  useEffect(() => {
    if (isDirect) {
      // Direct payment from Braintree - already processed
      setStatus("success");
      refreshUser();
    }
  }, [isDirect]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-rose-50 via-white to-amber-50/30 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-lg p-8 max-w-md w-full text-center border border-rose-100" data-testid="payment-success-card">
        {/* Logo */}
        <div className="flex items-center justify-center mb-8">
          <img src={LOGO_URL} alt="SingleSeen" className="h-24 w-auto" />
        </div>

        {status === "checking" && (
          <>
            <Loader2 className="w-16 h-16 text-rose-500 mx-auto mb-4 animate-spin" />
            <h1 className="font-serif text-2xl text-rose-900 mb-2">{t('payment.processingTitle')}</h1>
            <p className="text-rose-600 mb-8">{t('payment.processingDesc')}</p>
          </>
        )}

        {status === "success" && (
          <>
            <div className="w-20 h-20 rounded-full bg-emerald-100 flex items-center justify-center mx-auto mb-6">
              <CheckCircle className="w-10 h-10 text-emerald-600" />
            </div>
            <h1 className="font-serif text-2xl text-rose-900 mb-2" data-testid="success-heading">{t('payment.successTitle')}</h1>
            <p className="text-rose-600 mb-8">{t('payment.successDesc')}</p>
            <Button onClick={() => navigate("/dashboard")}
              className="w-full bg-gradient-to-r from-rose-500 to-pink-500 text-white hover:from-rose-600 hover:to-pink-600 rounded-full h-12"
              data-testid="go-to-dashboard-btn">
              {t('common.goToDashboard')}
            </Button>
          </>
        )}

        {status === "expired" && (
          <>
            <div className="w-20 h-20 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-6">
              <span className="text-4xl">⏱️</span>
            </div>
            <h1 className="font-serif text-2xl text-rose-900 mb-2">{t('payment.expiredTitle')}</h1>
            <p className="text-rose-600 mb-8">{t('payment.expiredDesc')}</p>
            <Button onClick={() => navigate("/pricing")}
              className="w-full bg-gradient-to-r from-rose-500 to-pink-500 text-white hover:from-rose-600 hover:to-pink-600 rounded-full h-12">
              {t('common.backToPricing')}
            </Button>
          </>
        )}

        {status === "timeout" && (
          <>
            <div className="w-20 h-20 rounded-full bg-amber-100 flex items-center justify-center mx-auto mb-6">
              <span className="text-4xl">⚠️</span>
            </div>
            <h1 className="font-serif text-2xl text-rose-900 mb-2">{t('payment.pendingTitle')}</h1>
            <p className="text-rose-600 mb-8">{t('payment.pendingDesc')}</p>
            <Button onClick={() => navigate("/dashboard")}
              className="w-full bg-gradient-to-r from-rose-500 to-pink-500 text-white hover:from-rose-600 hover:to-pink-600 rounded-full h-12">
              {t('common.goToDashboard')}
            </Button>
          </>
        )}
      </div>
    </div>
  );
};

export default PaymentSuccess;
